export const FIELDS = {
  ID: 'id',
  PART_NUMBER: 'partNumber',
  ON_HAND: 'onHand',
  OEMEXCESS: 'oemExcess',
  VENDOR_EXCESS: 'vendorExcess',
  CONSIGNMENT: 'consignment',
  IN_TESTING: 'inTesting',
  ALLOCATED: 'allocated',
  AVAILABLE: 'available',
  RETURNED: 'returned',
  DESTROYED: 'destroyed',
  INTERNAL_PN: 'internalPn',
  NSNNUMBER: 'nsnNumber',
  ALT_NUMBER: 'altNumber',
  SKU: 'sku',
  HARMONIZED_CODE: 'harmonizedCode',
  MANUFACTURER_ID: 'manufacturerId',
  MFG_NAME: 'mfgName',
  ALT_MANUFACTURER_ID: 'altManufacturerId',
  ALT_MFR: 'altMfr',
  INVENTORY_CLASS_ID: 'inventoryClassId',
  CLASS_NAME: 'className',
  INVENTORY_CATEGORY_ID: 'inventoryCategoryId',
  CATEGORY_NAME: 'categoryName',
  UO_MID: 'uoMId',
  UOM: 'uom',
  PACKAGE_ID: 'packageId',
  PACKAGE: 'package',
  PHYS_PKG: 'physPkg',
  PIECE_PER_PKG: 'piecePerPkg',
  LEAD_FREE: 'leadFree',
  DESCRIPTION: 'description',
  TEMP_RATING: 'tempRating',
  SIZE: 'size',
  VOLTAGE: 'voltage',
  AMPERAGE: 'amperage',
  RESOLUTION: 'resolution',
  WATTS: 'watts',
  CDM2: 'cdm2',
  COMMENTS: 'comments',
  DATE_CREATED: 'dateCreated',
  CREATED_BY_USER_ID: 'createdByUserId',
  DATE_MODIFIED: 'dateModified',
  MODIFIED_BY_USER_ID: 'modifiedByUserId',
  CREATED_BY: 'createdBy',
  CREATED_BY_USER_FULL_NAME: 'createdByUserFullName',
  MODIFIED_BY: 'modifiedBy',
  MODIFIED_BY_USER_FULL_NAME: 'modifiedByUserFullName',
  ACTIVE: 'active',
  ASSET_ACCOUNT_ID: 'assetAccountId',
  ACCOUNT_NAME: 'accountName',
  ASSET_ACCOUNT_NAME: 'assetAccountName',
  EXPENSE_ACCOUNT_ID: 'expenseAccountId',
  EXPENSE_ACCOUNT: 'expenseAccount',
  EXPENSE_ACCOUNT_NAME: 'expenseAccountName',
  INCOME_ACCOUNT_ID: 'incomeAccountId',
  INCOME_ACCOUNT: 'incomeAccount',
  INCOME_ACCOUNT_NAME: 'incomeAccountName',
  COST: 'cost',
  LIST_PRICE: 'listPrice',
  RESALE: 'resale',
  DISCOUNT1: 'discount1',
  DISCOUNT2: 'discount2',
  DISCOUNT3: 'discount3',
  DISCOUNT4: 'discount4',
  QTY_REQUIRED1: 'qtyRequired1',
  QTY_REQUIRED2: 'qtyRequired2',
  QTY_REQUIRED3: 'qtyRequired3',
  QTY_REQUIRED4: 'qtyRequired4',
  PRICE1: 'price1',
  PRICE2: 'price2',
  PRICE3: 'price3',
  PRICE4: 'price4',
  CONTRAST_RATIO: 'contrastRatio',
  ASPECT_RATIO: 'aspectRatio',
  OPER_TEMP: 'operTemp',
  STOR_TEMP: 'storTemp',
  POLARIZER_TYPE: 'polarizerType',
  BACKLIGHTING: 'backlighting',
  DATA_CONN: 'dataConn',
  BLCONN: 'blConn',
  EXPR1: 'expr1',
  EXPR2: 'expr2',
  EXPR3: 'expr3',
  FULL_NAME: 'fullName',
  IS_SERVICE: 'isService',
  SCHEDULE_B: 'scheduleB',
  ECCN: 'eccn',};